const users = {
  pageName: 'Users',
  mainTabs: {
    titleInvitations: 'Invitations',
    titleExistingUsers: 'Existing Users',
  },
  headerButtons: {
    invite: {
      inviteBtn: 'Invite',
    },
  },
  toast: {
    error: {
      default: 'Unkown error occured.',
      badResponse: 'User bad server response',
      create: {},
      edit: {
        change: 'Wrong old password',
      },
      unauthorized: 'Operation not authorized.',
    },
    success: {
      delete: {
        default: 'User deleted successfully',
      },
      create: {
        default: 'User has been created successfully.',
      },
      edit: {
        change: 'Password changed',
        default: 'User Updated.',
      },
      reset: {
        default: 'Reset Password email has been sent successfully.',
      },
    },
  },

  deleteModal: {
    header: 'Delete Users',
    body: 'You are about to delete {{num}} Users.',
  },

  create: {
    alreadyExistToast: {
      message: 'Error Occurred. Email already exists. Please try a different email.',
    },
    errorRequestToast: {
      message: 'Forbidden. You don`t have permissions to perform this action. Please contact an administrator.',
    },
    successToast: {
      message: 'Success! User Created Successfully',
    },
    validations: {
      firstName: 'First Name is required',
      lastName: 'Last Name is required',
      phone: {
        invalid: 'Phone is invalid',
        required: 'Phone is required',
        length: 'Phone should contain from 6 to 16 digits',
      },
      email: {
        required: 'Email is required',
        email: 'Invalid email address',
      },
      role: {
        required: 'Role is required',
      },
      supplier: {
        required: 'Supplier is required',
      },
    },
  },
  select: 'Select',
  edit: {
    modalRemoveConfirm: {
      header: 'Warning!',
      body: 'Are you sure you want to delete this user? Note: if associated with other sites, user will be removed from current site only.',
      modalRemoveConfirmBtn: 'Delete',
    },
    formTabs: {
      informationTab: 'Information',
      notesTab: 'Notes',
      historyTab: 'History',
    },
  },

  table: {
    filters: {
      role: 'Role',
    },
    headers: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      role: 'Role',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission require',
    },
  },
  isCompanyAdmin: 'Company Admin',

  form: {
    header: {
      createUser: {
        title: 'Create',
      },

      updateUser: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    selectOption: {
      select: 'Select',
    },
    information: {
      details: {
        header: 'Personal Details',
        fields: {
          firstName: 'First Name',
          lastName: 'Last Name',
          name: 'Name',
          phone: 'Phone',
          email: 'Email',
          site: 'Site',
        },
      },
      roles: {
        header: 'Sites And Roles',
        fields: {
          role: 'Role',
          site: 'Site',
        },
        buttons: {
          addAccess: 'Add Site',
        },
      },
      actions: {
        header: 'Actions',
        buttons: {
          delete: 'Delete',
          resetPassword: 'Reset Password',
          changePassword: 'Change Password',
        },
      },
    },
    valdations: {
      firstName: 'First Name is required',
      lastName: 'Last Name is required',
      phone: 'Phone is required',
      supplier: 'Supplier is required',
      role: 'Role is required',
      email: {
        required: 'Email is required',
        email: 'Invalid email address',
      },
    },
  },
};

export default users;
